import { React, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@material-ui/core';
import PropTypes from 'prop-types';
import RequestContainer from './RequestContainer';

import {
  getTickets,
  openModalSuccessCreate,
} from '../../../../../redux/actions/TicketActions';

const RequestList = ({ ...props }) => {
  const { requests, mobile } = props;
  const dispatch = useDispatch();
  const { ticketNoProductStatus, ticket } = useSelector(
    (innerState) => innerState.ticketReducer,
  );

  useEffect(() => {
    if (ticketNoProductStatus === 'succeded') {
      dispatch(getTickets());
      dispatch(
        openModalSuccessCreate({
          changeMessage: 'Tu número de solicitud es:',
          newValue: ticket.ticketId,
          noProduct: true,
        }),
      );
    }
  }, [ticketNoProductStatus]);

  return (
    <Box margin={mobile ? '0px -16px' : ''}>
      <RequestContainer requests={requests} mobile={mobile} />
    </Box>
  );
};

RequestList.propTypes = {
  requests: PropTypes.array,
  mobile: PropTypes.bool,
};

export default RequestList;
